export class ArbetsorderProduktvalTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        cbx: "Endast med produktionsmål",

        Produktval: "Produktval",
        mallar: "Produktionsmallar",
        simulera: "Simulera",
        hamta: "Hämta från kontrakt",
        confirmHeader: "Vill du spara dina ändringar innan du utbytessimulerar?",
        confirmHeaderRensa: "Vill du rensa val av produkt?",
        confirmHeaderMall: "Vill du ersätta val av produkt?",
        confirmTextMall: "Befintliga val av handelssortiment, produkter och produktinstruktioner ersätts med vald produktionsmall",
        confirmHeaderVirkeskopProduktMall: "Vill du ersätta val av produkt?",

        confirmTextVirkeskopProduktMall: "Befintliga val av handelssortiment, produkter och produktinstruktioner ersätts med vald produktionsmall tillsammans med handelssortiment och volymer från förkalkylen",
        confirmHeaderVirkeskop: "Vill du spara dina ändringar innan du hämtar val och volymer?",
        confirmInfoTextVirkeskop: "Om du hämtar val och volymer utan att spara först kommer du att förlora dina ändringar.",
        confirmInfoText: "Om du svarar 'Ja' kommer dina ändringar sparas innan utbytessimulering körs.",
        confirmTextRensa: "Befintliga val av handelssortiment, produkter och produktinstruktion i produkt tas bort.",
        senastSimuleradText: "Senast simulerad",
        senastVolymhamtadText: "Senast hämtat kl",
        produktsattUtfort: "Produktsatt utfört",
        produktsattInfoBox: "Produktsatt kräver att alla produkter har PIN.",
        borttagProduktKvantitetHeader: "Ta bort produkt?"
    };
}
